module.exports = __webpack_public_path__ + "static/media/98.42cffb04.png";